import React from 'react';
import { withClerk, withUser } from '../contexts';
import { useUserContext } from '../contexts/UserContext';

export const SignedIn: React.FC = withUser(({ children }) => {
  return <>{children}</>;
}, 'SignedIn');

export const SignedOut: React.FC = withClerk(({ children }) => {
  const userCtx = useUserContext();
  return userCtx.value === null ? <>{children}</> : null;
}, 'SignedOut');

export const ClerkLoaded: React.FC = withClerk(({ children }) => {
  return <>{children}</>;
}, 'ClerkLoaded');

export const RedirectToSignIn = withClerk(({ clerk }) => {
  const { client, environment, session } = clerk;
  const hasActiveSessions =
    client.activeSessions && client.activeSessions.length > 0;
  React.useEffect(() => {
    if (session === null && hasActiveSessions && environment) {
      const { afterSignOutOneUrl } = environment.displayConfig;
      void clerk.navigate(afterSignOutOneUrl);
    } else {
      clerk.redirectToSignIn();
    }
  }, []);
  return null;
}, 'RedirectToSignIn');

export const RedirectToSignUp = withClerk(({ clerk }) => {
  React.useEffect(() => {
    clerk.redirectToSignUp();
  }, []);
  return null;
}, 'RedirectToSignUp');

export const RedirectToUserProfile = withClerk(({ clerk }) => {
  React.useEffect(() => {
    clerk.redirectToUserProfile();
  }, []);
  return null;
}, 'redirectToUserProfile');
